import { z } from "zod";
import {
  AttributeSchema,
  createAttributeSchema,
  updateAttributeSchema,
  VariantAttributeValueSchema,
  createVariantAttributeValueSchema,
  updateVariantAttributeValueSchema,
} from "@/lib/validations/products/attributes";
import { ProductVariantSchema } from "@/lib/validations/products/product";

// Core attribute types
export type Attribute = z.infer<typeof AttributeSchema>;
export type CreateAttributeInput = z.infer<typeof createAttributeSchema>;
export type UpdateAttributeInput = z.infer<typeof updateAttributeSchema>;

// Variant and value types
    export type VariantAttributeValue = z.infer<typeof VariantAttributeValueSchema>;
    export type ProductVariant = z.infer<typeof ProductVariantSchema>;
export type CreateVariantAttributeValue = z.infer<
  typeof createVariantAttributeValueSchema
>;
export type UpdateVariantAttributeValue = z.infer<
  typeof updateVariantAttributeValueSchema
>;

/** Fields that can be edited in an attribute */
export type AttributeEditableField = "name";

/** Interface defining permissions for attribute fields */
export interface AttributeFieldPermissions {
  editable: AttributeEditableField[];
  viewable: AttributeEditableField[];
}

/** Fields that can be used for sorting attributes */
export const AttributeSortable = ["name", "created", "updated"] as const;
export type AttributeSortField = (typeof AttributeSortable)[number];

/** Simple attribute type for basic lists */
export interface SimpleAttribute {
  id: string;
  name: string;
}

/** Attribute with relationships */
export interface AttributeWithRelations extends Attribute {
  products?: Array<{
    id: string;
    title: string;
    value: string;
  }>;
  variant_values?: VariantAttributeValue[];
}
